import React from 'react'
import { observable } from 'mobx'
import { observer } from 'mobx-react'
import * as linkConst from '../../../constants/link_constants'
import EmbededEntityInput from '../../input/embedded_entity'
import OptionsField from 'react-mobx-admin/components/common/field/opts'
import SelectInput from '../../input/select'
import SelectWithSuggestions from '../../input/select_suggested'
import TextInput from 'bstrap-react-mobx-admin/input/text'
import Validators from '../../../state/entity_confs/validators'
import sortBy from 'lodash/sortBy'
import { Button } from 'react-bootstrap'

const RolesEdit = ({ store, updateField, ...rest }) => {
  const newArtists = observable([])

  const _RolesEditForm = observer(({ record, updateFormField, errors }) => {
    const hasID = record.has('id')
    const state = store.cv.subentities.roles
    const items = store.cv.record.get('roles')

    if (!record.has('added')) {
      newArtists.clear()
    }

    const roleOrder = () => <TextInput
      attr={'role_order'}
      disabled
      errors={errors}
      label={store.__('Order')}
      onChange={updateFormField}
      record={record}
      type='number' />

    const addArtist = () => {
      const order = store.cv.record && (items.length + 2 + newArtists.length)
      state.validators['person_id' + '__' + order] = Validators.isMandatory(store)
      newArtists.push(<SelectWithSuggestions
        attr={'person_id' + '__' + order}
        errors={errors}
        label={store.__('artist')}
        labelattr='name'
        onChange={updateFormField}
        optionsattr={'persons'}
        optionsrecord={store.options}
        record={record}
        valueattr='id' />)
      record.set('added', true)
      store._runSubentityValidators(state)
      store._runSubentityGlobalValidator(state)
    }

    const removeArtist = () => {
      errors.clear()
      newArtists.pop()
      const order = store.cv.record && (items.length + 2 + newArtists.length)
      delete state.validators['person_id' + '__' + order]
      store._runSubentityValidators(state)
      store._runSubentityGlobalValidator(state)
    }

    return (
      <div className='row'>
        <div className='col-xs-12'>
          <SelectInput
            label={store.__('role')}
            attr={'role_id'}
            record={record}
            onChange={updateFormField}
            optionsrecord={store.options}
            optionsattr={'Roles'}
            labelattr='text'
            errors={errors} />
          {!hasID && roleOrder()}
          <SelectWithSuggestions
            label={store.__('artist')}
            attr={'person_id'}
            record={record}
            onChange={updateFormField}
            optionsrecord={store.options}
            optionsattr={'persons'}
            labelattr='name'
            valueattr='id'
            errors={errors} />
          {hasID && roleOrder()}
          {!hasID && newArtists.map(v => v)}
          {!hasID &&
            <Button bsStyle='default' onClick={() => addArtist()} style={{ marginBottom: '1.5em' }}>
              <em className='glyphicon glyphicon-plus-sign'/>&nbsp; {store.__('Add another artist')}
            </Button>}
          {!hasID && newArtists.length > 0 &&
            <Button bsStyle='default' onClick={() => removeArtist()} style={{ marginBottom: '1.5em', marginLeft: '0.1em' }}>
              &nbsp;<em className='glyphicon glyphicon-remove'/>&nbsp;
            </Button>}
        </div>
      </div>
    )
  })

  return (
    <EmbededEntityInput
      dragbleHelperClass='react-sortable-dragable-helper'
      dragbleListEntity={
        {
          handle: true,
          disableFn: i => !i.role_order && !i.id,
          editIndex: index => parseInt(index) + 1,
          dragToggleDelay: 300,
          onDragEnd: ({ oldIndex, newIndex }) => {
            const items = store.cv.record.get('roles')
            sortBy(items, ['role_order', 'id']).map((value, key) => {
              const newOrder = (key + 1)
              if (oldIndex > newIndex) {
                if (newOrder < newIndex && !value.role_order) {
                  value.role_order = newOrder
                  value.updated = new Date()
                } else if (newOrder >= newIndex && newOrder < oldIndex && value.role_order) {
                  value.role_order = newOrder + 1
                  value.updated = new Date()
                } else if (newOrder === oldIndex) {
                  value.role_order = newIndex
                  value.updated = new Date()
                }
              } else if (oldIndex < newIndex) {
                if (newOrder < oldIndex) {
                  value.role_order = newOrder
                  value.updated = new Date()
                } else if (newOrder > oldIndex && newOrder <= newIndex) {
                  value.role_order = newOrder - 1
                  value.updated = new Date()
                } else if (newOrder === oldIndex) {
                  value.role_order = newIndex
                  value.updated = new Date()
                }
              }
            })
          }
        }
      }
      store={store}
      helper='films/common/roles'
      label={store.__(linkConst.LINK_PERSONS_TITLE2)}
      attr={'roles'}
      edit_title={store.__('edit a person')}
      add_title={store.__('add a person')}
      onAddRow={(rec) => {
        const state = store.cv.subentities.roles
        const items = store.cv.record.get('roles')
        const saved = []
        let newOrder = rec.role_order
        Object.keys(rec).map(k => {
          delete state.validators['person_id' + '__' + newOrder]
          if (k.indexOf('person_id') > -1 && !saved.includes(rec[k])) {
            items.push(Object.assign(rec, { person_id: rec[k], role_order: newOrder }))
            saved.push(rec[k])
            newOrder++
          }
        })
        delete state.validators['person_id' + '__' + newOrder]
      }}
      fields={[
        (attr, row) => {
          const DetailLink = ({ text }) => (
            <a href='javascript:void(0)' onClick={() => {
              store.beforeEditViewExit() && store.router.goTo(store.views.entity_detail, {
                entityname: linkConst.LINK_PERSONS, id: row.person_id
              }, store)
            }}><i className='glyphicon glyphicon-share-alt' />&nbsp;{text}</a>
          )
          return (
            <OptionsField
              attr={attr}
              val={row[attr]}
              options={store.options.get('persons')}
              labelattr='name'
              valueattr='id'
              Component={DetailLink} />
          )
        },
        (attr, row) => (<OptionsField attr={attr} val={row[attr]} options={store.options.get('Roles')} labelattr='text' />),
        (attr, row) => (<span title={store.__('Click and move.')}>{
          !row[attr] && !row.id ? '' : <i className='glyphicon glyphicon-th-large' style={{ cursor: 'move' }} />
        } &nbsp; {row[attr]}</span>)
        // (attr, row) => (<TextField attr={attr} val={row[attr]} />)
      ]}
      rowId={(row) => (row.person_id)}
      EditForm={_RolesEditForm} {...rest}
    />
  )
}

// export default
export default observer(RolesEdit)
